var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackToTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 118,
    viewBox: "0 0 107 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29_1369)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 58,
    height: 58,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 10.5,
    width: 57,
    height: 57,
    rx: 9.5,
    stroke: "#2353FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_1369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0656 48.0654C55.6556 48.0654 52.0656 44.4754 52.0656 40.0654C52.0656 35.6554 55.6556 32.0654 60.0656 32.0654C64.4756 32.0654 68.0656 35.6554 68.0656 40.0654C68.0656 44.4754 64.4756 48.0654 60.0656 48.0654ZM60.0656 50.0654C65.5856 50.0654 70.0656 45.5854 70.0656 40.0654C70.0656 34.5454 65.5856 30.0654 60.0656 30.0654C54.5456 30.0654 50.0656 34.5454 50.0656 40.0654C50.0656 45.5854 54.5456 50.0654 60.0656 50.0654ZM59.0656 40.0654V43.0654C59.0656 43.6154 59.5156 44.0654 60.0656 44.0654C60.6156 44.0654 61.0656 43.6154 61.0656 43.0654V40.0654H62.8556C63.3056 40.0654 63.5256 39.5254 63.2056 39.2154L60.4156 36.4254C60.2156 36.2254 59.9056 36.2254 59.7056 36.4254L56.9156 39.2154C56.8464 39.2859 56.7998 39.3753 56.7814 39.4723C56.763 39.5693 56.7737 39.6695 56.8122 39.7604C56.8507 39.8513 56.9152 39.9288 56.9977 39.9831C57.0802 40.0374 57.1768 40.066 57.2756 40.0654H59.0656Z",
    fill: "#2353FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29_1369",
    x: 0,
    y: 0,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.141176 0 0 0 0 0.227451 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29_1369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29_1369",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_1369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8197,
    height: 22.8197,
    fill: "white",
    transform: "translate(48.0654 28.0645)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTop);
export default __webpack_public_path__ + "static/media/BackToTop.9398630ea8bf0b74d9c7be54dd377b96.svg";
export { ForwardRef as ReactComponent };